angular.module('MW.InsDashboard.SocialReachWidget.SocialReachChartDataFormattingService', [
    'DashboardChartConfigService'
])
.constant('SocialReachChartScale', {
    SCALED: 'logarithmic',
    STANDARD: 'linear',
})
.service('SocialReachChartDataFormattingService', [
    'DashboardChartConfigService',
    'SocialReachChartScale',
    function (DashboardChartConfigService, SocialReachChartScale) {
        var sourceSettings = {};
        Object.defineProperties(sourceSettings, {
            YouTube: {
                value: {
                    id: 'YouTube',
                    name: 'YouTube',
                    color: '#CD201F',
                    type: 'scatter'
                },
                writable: false
            },
            Twitter: {
                value: {
                    id: 'Twitter',
                    name: 'Twitter',
                    color: '#55ACEE',
                    type: 'scatter'
                },
                writable: false
            },
            Facebook: {
                value: {
                    id: 'Facebook',
                    name: 'Facebook',
                    color: '#3C5B9A',
                    type: 'scatter'
                },
                writable: false
            }
        });

        var ONE_TRILLION = 1e12,
            ONE_BILLION = 1e9,
            ONE_MILLION = 1e6,
            ONE_THOUSAND = 1000;

        function getRoundedValueAndDataLabelUnits (value) {
            var absValue = Math.abs(value);
            var roundedValue = absValue,
                dataLabelUnits = '';
            if(absValue >= ONE_TRILLION) {
                roundedValue = absValue / ONE_TRILLION;
                dataLabelUnits = 'T';
            } else if(absValue >= ONE_BILLION) {
                roundedValue = absValue / ONE_BILLION;
                dataLabelUnits = 'B';
            } else if(absValue >= ONE_MILLION) {
                roundedValue = absValue / ONE_MILLION;
                dataLabelUnits = 'M';
            } else if(absValue >= ONE_THOUSAND) {
                roundedValue = absValue / ONE_THOUSAND;
                dataLabelUnits = 'k';
            }
            return {
                roundedValue: roundedValue,
                dataLabelUnits: dataLabelUnits
            };
        }

        function isValidValueForFormatting(value) {
            if(value === 0) {
                return false;
            } else if(value === '0') {
                return false;
            } else if(value === '') {
                return false;
            }
            return true;
        }

        return {
            sourceSettings: sourceSettings,
            formatPercentageDataLabels: function (value) {
                if (!isValidValueForFormatting(value)) {
                    return '';
                }
                return value.toFixed(0) + '%';
            },
            formatYAxisDataLabels: function (value) {
                if (!isValidValueForFormatting(value)) {
                    return '';
                }

                var roundedValueAndDataLabel = getRoundedValueAndDataLabelUnits(value),
                    roundedValue = roundedValueAndDataLabel.roundedValue,
                    dataLabelUnits = roundedValueAndDataLabel.dataLabelUnits;

                if(roundedValue === parseInt(roundedValue)) {
                    return roundedValue.toFixed(0) + dataLabelUnits;
                }

                return this.formatFixedDecimalCountDataLabels(value, 1);
            },
            formatFixedDecimalCountDataLabels: function (value, decimalCount) {
                if (!isValidValueForFormatting(value)) {
                    return '';
                }

                var roundedValueAndDataLabel = getRoundedValueAndDataLabelUnits(value),
                    roundedValue = roundedValueAndDataLabel.roundedValue,
                    dataLabelUnits = roundedValueAndDataLabel.dataLabelUnits;

                if(dataLabelUnits === '') {
                    roundedValue = roundedValue.toFixed(0);
                } else {
                    roundedValue = roundedValue.toFixed(decimalCount);
                }

                return roundedValue + dataLabelUnits;
            },
            formatFixedPrecisionDataLabels: function (value, isMaximized) {
                if (!isValidValueForFormatting(value)) {
                    return '';
                }

                var roundedValueAndDataLabel = getRoundedValueAndDataLabelUnits(value),
                    roundedValue = roundedValueAndDataLabel.roundedValue,
                    dataLabelUnits = roundedValueAndDataLabel.dataLabelUnits;

                var precision = isMaximized ? 3 : 2;

                // using parseFloat() is a hack to reduce precision without using scientific notation
                // see https://stackoverflow.com/questions/4689142/how-to-display-the-result-of-toprecision-without-the-scientific-notation
                roundedValue = parseFloat(roundedValue.toPrecision(precision));

                return roundedValue + dataLabelUnits;
            },
            getDateCategories: function (statisticsArray, dateStart, dateEnd, granularity) {
                var dateCategories = [];
                for (var epoch in statisticsArray) {
                    if(!statisticsArray.hasOwnProperty(epoch)) {
                        continue;
                    }
                    var dateLabel = DashboardChartConfigService.formatTimeInterval(moment(parseInt(epoch)), granularity, dateStart, dateEnd);
                    dateCategories.push(dateLabel);
                }
                return dateCategories;
            },
            getChartType: function (percentageMode, chartScale) {
                if (!percentageMode && chartScale === SocialReachChartScale.SCALED) {
                    return 'logarithmic';
                }

                return 'linear';
            },
            createTickPositions: function (statisticsArray) {
                var arraySize = Object.keys(statisticsArray).length;
                return Array.apply(null, Array(arraySize)).map(function (_, i) {return i;});
            },
            calculateChange: function (previousTotal, newTotal) {
                if (newTotal == 0) {
                    return -100;
                } else if (previousTotal == 0) {
                    return 100;
                }
                return (((newTotal - previousTotal) / previousTotal) * 100);
            },
            calculateDataPoint: function (settings, individualTotal, index, date, total, totalChange, percentageMode) {
                if(total === 0) {
                    return;
                }

                var percentage = ((individualTotal / total) * 100);
                var value = individualTotal || null;
                if (percentageMode) {
                    value = percentage;
                }

                if (!value) {
                    return;
                }

                return {
                    x: index,
                    y: value,
                    marker: null,
                    change: totalChange,
                    count: individualTotal,
                    perc: percentage,
                    color: settings.color,
                    date: date,
                    source: settings.id.toLowerCase()
                };
            },
            areTotalsLabelsVisible: function (labelsAreVisible, inPercentageMode) {
                return labelsAreVisible && !inPercentageMode;
            }
        };
    }]);
